/**
 * Gets the rank title based on the user level.
 */
export const getLevelTitle = (level: number): string => {
  if (level >= 50) return "Legendary Publisher";
  if (level >= 40) return "Media Mogul";
  if (level >= 30) return "Viral Sensation";
  if (level >= 20) return "Marketing Strategist";
  if (level >= 15) return "Community Builder";
  if (level >= 10) return "Aspiring Promoter";
  if (level >= 5) return "Indie Adventurer";
  return "Unknown Developer";
};
